import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import {PointsRequest, PointsRequestStatus} from "@irati/types"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {Body, H5} from "@irati/ui/src/Typography"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import {IntlCtx} from "@irati/utils/lang/types"
import React from "react"
import styled, {css} from "styled-components"
interface Props {
  onHide: () => void
  pointsRequest: PointsRequest
}
const StyledRequestContainer = styled(Flex)`
  ${({theme}) => css`
    background: ${theme.colors.greys.grey03};
    flex-direction: column;
    border-radius: ${theme.spacing.one};
    padding: ${theme.spacing.oneAndHalf};
  `}
`
const FieldsToRender = [
  {
    name: "responseMessage",
    label: "wallet.reward.requestPoints.label.response",
    transformer: (pointsRequest: PointsRequest, intl: IntlCtx) =>
      pointsRequest.responseMessage || intl.formatMessage({id: "platform.msg.noContent"})
  }
]
const UpdateRequestPointsSuccess = (props: Props) => {
  const {pointsRequest, onHide} = props
  const intl = useIntl()
  return (
    <Flex direction="column" gap={2}>
      <Body>
        {pointsRequest.status === PointsRequestStatus.StatusApproved && (
          <FormattedMessage id="wallet.reward.requestPoints.success.text" values={{user: firstnameLastname(pointsRequest.requester)}} />
        )}
        {pointsRequest.status === PointsRequestStatus.StatusDeclined && (
          <FormattedMessage id="wallet.reward.requestPoints.decline.text" values={{user: firstnameLastname(pointsRequest.requester)}} />
        )}
        {pointsRequest.status === PointsRequestStatus.StatusCancelled && (
          <FormattedMessage id="wallet.reward.requestPoints.cancelled.text" />
        )}
      </Body>
      {pointsRequest.status !== PointsRequestStatus.StatusCancelled && (
        <StyledRequestContainer>
          {FieldsToRender.map(({name, label, transformer}) => (
            <Flex key={name} marginBottom={2} direction="column" gap={1}>
              <H5 weight="bold">
                <FormattedMessage id={label} />
              </H5>
              <Body small>{transformer(pointsRequest, intl)}</Body>
            </Flex>
          ))}
        </StyledRequestContainer>
      )}
      <Button full primary marginTop={3} onClick={onHide}>
        <FormattedMessage id="wallet.reward.requestPoints.btn.backToList" />
      </Button>
    </Flex>
  )
}

export default UpdateRequestPointsSuccess
